export default __webpack_public_path__ + "locales/hy-AM/People.json?hash=a668c60e9861b0a820337759687e2c21";